import { combineReducers } from 'redux';
import ui from '@/vdp/Device/reducers';
import {
  experimentation,
  router,
  user,
  vehicle
} from '@/vdp/VehicleDetailsContainer/reducers';

const createRootReducer = combineReducers({
  ui,
  user,
  vehicle,
  experimentation,
  router
});

export default createRootReducer;
